import { dimensionsKeys } from "../../../../utils";
import { Box, Flex, GridItem, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { ArrowDown, ArrowsDownUp, ArrowUp, Trash } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

function DimensionsGridHeaderRow({
  organizationStructure,
  scope,
  consumptionTypesAttr,
  permanentColumns,
  isPreview,
  sortState,
  onToggleValueSort,
  onClearAll,
}) {
  const { t } = useTranslation("translation");
  const valueLabel = t("organizationQuestionnaire.dimensionsGrid.value");
  const headerTitles = [];

  dimensionsKeys.forEach(dimKey => {
    if (organizationStructure.dimensions[dimKey]) {
      headerTitles.push(organizationStructure.dimensions[dimKey].name);
    }
  });

  headerTitles.push(...permanentColumns);

  return headerTitles.map((headerTitle, idx) => {
    const isValueColumn = headerTitle === valueLabel;
    const sortedAsc = isValueColumn && sortState?.key === "value" && sortState?.direction === "asc";
    const sortedDesc = isValueColumn && sortState?.key === "value" && sortState?.direction === "desc";
    const sortIndicator = isValueColumn && onToggleValueSort ? (
      sortedAsc ? <ArrowUp size={12} /> :
      sortedDesc ? <ArrowDown size={12} /> :
      <ArrowsDownUp size={12} color="#A0AEC0" />
    ) : null;

    const interactive = isValueColumn && !!onToggleValueSort;
    const isActionColumn = !isPreview && headerTitle === "" && idx === headerTitles.length - 1;

    return <GridItem
      key={`heading-${headerTitle}-${scope === "one" ? consumptionTypesAttr : ""}`}
      px={isActionColumn ? 4 : 4} py={isActionColumn ? 2 : 3}
      display="flex"
      alignItems="center"
      bg="gray.50"
      borderBottom="1px solid"
      borderColor="gray.200"
      colSpan={isPreview ? 2 : headerTitle !== "" ? 2 : 1}
      position="sticky"
      top={0}
      zIndex={2}
      cursor={interactive ? "pointer" : "default"}
      onClick={interactive ? onToggleValueSort : undefined}
      _hover={interactive ? { color: "gray.700" } : undefined}
      userSelect="none"
    >
      {isActionColumn ? (
        // Mirror the row Flex so the trash circle lines up vertically with
        // the per-row Trash IconButton beneath it.
        <Flex>
          <Box w={10} h={10} flexShrink={0} aria-hidden />
          {onClearAll ? (
            <Tooltip label="Clear all data" placement="top" hasArrow>
              <IconButton
                aria-label="Clear all data"
                icon={<Trash size={18} />}
                variant="ghost"
                color="red.500"
                _hover={{ color: "red.600", bg: "transparent" }}
                onClick={onClearAll}
              />
            </Tooltip>
          ) : null}
        </Flex>
      ) : (
        <Flex align="center" gap={1} overflow="hidden">
          <Text
            fontSize="13px"
            fontWeight="600"
            color={sortedAsc || sortedDesc ? "gray.700" : "gray.500"}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            title={typeof headerTitle === "string" ? headerTitle : ""}
          >
            {headerTitle}
          </Text>
          {sortIndicator}
        </Flex>
      )}
    </GridItem>;
  });
}


export default DimensionsGridHeaderRow;
